import moment from 'moment';
import { show as showDialog, close as closeDialog } from '@/plugins/dialog';
import { LOGOUT_REASONS } from '@/data/auth';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import store from '@/store';

export function buildSessionEndedMessage({ logoutReason }) {
  let message = 'Sua sessão foi encerrada';

  if (logoutReason) {
    if (logoutReason === LOGOUT_REASONS.SESSION_REPLACED) {
      message += ' porque sua conta foi acessada em outro dispositivo.';
    } else if (logoutReason === LOGOUT_REASONS.ADMIN_LOGOUT) {
      message += ' por um gestor da conta.';
    } else if (logoutReason === LOGOUT_REASONS.INACTIVITY_TIMEOUT) {
      message += ' por inatividade.';
    }
  }

  return message;
}

export function showSessionEndedDialog({ logoutReason, createdAt, ip }) {
  closeDialog();

  const message = buildSessionEndedMessage({ logoutReason });

  const htmlParts = [
    `<div class="text-primary">${message}</div>`,
  ];

  if (createdAt || ip) {
    let info = '';
    if (createdAt) {
      info += `<span class="mr-1">${moment(createdAt).calendar()}</span>`;
    }
    if (ip) {
      info += `<span class="mr-1">(Endereço de IP ${ip})</span>`;
    }
    htmlParts.push(`<div class="mt-2 text-small text-dark-gray">${info}</div>`);
  }

  showDialog('Sessão encerrada', {
    html: htmlParts.join('\n'),
    closable: false,
    buttons: [{
      label: 'OK',
      classes: 'btn-primary',
      click: () => {
        closeDialog();
        router.push('/login');
        store.dispatch('resetAuthState');
      },
    }],
  });
}
